import { IdTutorialStep } from "../IdTutorialStep";
import { selectTutorialConfigData } from "../selectors/selectTutorialConfigData";
export var checkTutorialConstructConstructionProgress = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var _a = selectTutorialConfigData(state), tutorialStepConfig = _a.tutorialStepConfig, nextTutorialStepConfig = _a.nextTutorialStepConfig;
    if (tutorialStepConfig.nextStep !== IdTutorialStep.constructWindmill_constructionProgress) {
        return undefined;
    }
    if (nextTutorialStepConfig.buildingId === undefined && action.building === undefined) {
        return undefined;
    }
    return action.building.balancing.id === nextTutorialStepConfig.buildingId ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/checks/checkTutorialConstructConstructionProgress.ts
// module id = 2465
// module chunks = 3